import React, { useEffect, useImperativeHandle, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import classes from '../../../pages/content/AddContents.module.scss';
import { Field } from "formik";

interface Props {
  id: string;
  type: string;
  name: string;
  minLength?: number;
  maxLength?: number;
  placeholder?: string;
  classes?: string;
  value?: string;
  ref?: HTMLInputElement;
  readonly?: boolean;
  autocomplete?: string;
  tags:  string[];
  setTags:any;
}

interface IImperativeHandler {
  focus: () => void;
  value?: string;
}
const TagInput =((props:Props): JSX.Element  => {

  const inputRef = useRef<HTMLInputElement | null>(null);
  const [value, setValue] = useState(props.value || "");
  const [inputTags, setInputTags] = useState<string[]>([]);
  const { t } = useTranslation();

  useEffect(()=>{
    setInputTags([]);
    setInputTags([...props?.tags]);
  },[props?.tags]);


  const inputChangeHandler = (e: React.FormEvent<HTMLInputElement>) => {
    setValue(e.currentTarget.value);
  }

  const handleRemoveTag = (index:number) => {
    const newTags = props?.tags.filter((_, i) => i !== index);
    props?.setTags([...newTags]);
  };

  const handleKeyDown = (event:any) => {
    let tags:any[] = [];
    if (event.key === 'Enter' && value.trim()) {
        event.preventDefault();
        tags = [...props?.tags, value.trim()];
        props?.setTags([...tags]);
        setValue('');
    } else if (event.key === 'Backspace' && !value && tags.length) {
        const newTags = tags.slice(0, -1);
        props?.setTags([...newTags]);
    }
  };

  return (
    <div className={`${classes.form__control} ${props.classes}`}>
      <label htmlFor={props.id}>{t(`${props.name}`)}</label>
      <Field
        ref={inputRef}
        id={props.id}
        minLength={props.minLength}
        maxLength={props.maxLength}
        type={props.type}
        placeholder={props.placeholder}
        name={props.name}
        className={classes.input}
        value={value}
        readOnly={props.readonly || false}
        onChange={inputChangeHandler}
        autoComplete={props.autocomplete || "off"}
        onKeyDown={handleKeyDown}
      />
       <div className="flex flex-wrap py-3 px-1 gap-1" >
                {inputTags.map((tag, index) => (
                    <div key={index} className="flex items-center justify-center bg-[#f1f1f1]  border-[#e0e0e0] border-[1px] px-[5px] m-[2px] rounded-[4px]" >
                        <span className="text-[16px]">{tag}</span>
                        <button  type="button" className="m-[5px] text-[black] cursor-pointer border-0 bg-transparent"
                            onClick={() => handleRemoveTag(index)} >
                            x
                        </button>
                    </div>
                ))}
                
            </div>
        </div>
  );
});

export default TagInput;


export const extractCssColor = (color:string) => {
  const colorNames = [
      "IndianRed", "LightCoral", "Salmon", "DarkSalmon", "LightSalmon", "Crimson", "Red", "FireBrick", "DarkRed",
      "Pink", "LightPink", "HotPink", "DeepPink", "MediumVioletRed", "PaleVioletRed",
      "LightSalmon", "Coral", "Tomato", "OrangeRed", "DarkOrange", "Orange",
      "Gold", "Yellow", "LightYellow", "LemonChiffon", "LightGoldenrodYellow", "PapayaWhip", "Moccasin", "PeachPuff", "PaleGoldenrod", "Khaki", "DarkKhaki",
      "Lavender", "Thistle", "Plum", "Violet", "Orchid", "Fuchsia", "Magenta", "MediumOrchid", "MediumPurple", "RebeccaPurple", "BlueViolet", "DarkViolet", "DarkOrchid", "DarkMagenta", "Purple", "Indigo", "SlateBlue", "DarkSlateBlue", "MediumSlateBlue",
      "GreenYellow", "Chartreuse", "LawnGreen", "Lime", "LimeGreen", "PaleGreen", "LightGreen", "MediumSpringGreen", "SpringGreen", "MediumSeaGreen", "SeaGreen", "ForestGreen", "Green", "DarkGreen", "YellowGreen", "OliveDrab", "Olive", "DarkOliveGreen", "MediumAquamarine", "DarkSeaGreen", "LightSeaGreen", "DarkCyan", "Teal",
      "Aqua", "Cyan", "LightCyan", "PaleTurquoise", "Aquamarine", "Turquoise", "MediumTurquoise", "DarkTurquoise", "CadetBlue", "SteelBlue", "LightSteelBlue", "PowderBlue", "LightBlue", "SkyBlue", "LightSkyBlue", "DeepSkyBlue", "DodgerBlue", "CornflowerBlue", "MediumSlateBlue", "RoyalBlue", "Blue", "MediumBlue", "DarkBlue", "Navy", "MidnightBlue",
      "Cornsilk", "BlanchedAlmond", "Bisque", "NavajoWhite", "Wheat", "BurlyWood", "Tan", "RosyBrown", "SandyBrown", "Goldenrod", "DarkGoldenrod", "Peru", "Chocolate", "SaddleBrown", "Sienna", "Brown", "Maroon",
      "White", "Snow", "HoneyDew", "MintCream", "Azure", "AliceBlue", "GhostWhite", "WhiteSmoke", "SeaShell", "Beige", "OldLace", "FloralWhite", "Ivory", "AntiqueWhite", "Linen", "LavenderBlush", "MistyRose",
      "Gainsboro", "LightGray", "Silver", "DarkGray", "Gray", "DimGray", "LightSlateGray", "SlateGray", "DarkSlateGray", "Black"
  ];

  const colorRegex = new RegExp(`\\b(${colorNames.join('|')})\\b`, 'i');
  
  const match = color.match(colorRegex);
  return match ? match[0] : '';
}